// import React,{useState} from "react";
// import axios from "axios";
// import {useNavigate} from "react-router-dom";

// function Login(){

// const navigate=useNavigate();

// const [formData,setFormData]=useState({
// username:"",
// password:""
// });

// const [loading,setLoading]=useState(false);


// const handleChange=(e)=>{
// setFormData({
// ...formData,
// [e.target.name]:e.target.value
// });
// };


// const handleSubmit = async (e) => {
//   e.preventDefault();
//   setLoading(true);

//   try {
//     const res = await axios.post(
//       "http://localhost:8000/api/login/",
//       formData
//     );

//     console.log("login response", res.data);

//     // 1. Extract data based on your REAL response structure
//     const { token, role, user_id } = res.data;

//     // 2. Store the Token (Crucial for Sidebar/Menus)
//     localStorage.setItem("token", token.token); 
//     localStorage.setItem("refresh", token.refresh);

//     // 3. Store User Info
//     localStorage.setItem("user", JSON.stringify({
//       id: user_id,
//       role: role
//     }));

//     // 4. Navigation Logic
//     if (role === "Admin") {
//       navigate("/admin/dashboard");
//     } else if (role === "PM") {
//       navigate("/pm/dashboard");
//     } else {
//       alert("Unknown role: " + role);
//     }

//   } catch (err) {
//     console.error(err.response?.data || err);
//     alert(err.response?.data?.error || "Login failed");
//   } finally {
//     setLoading(false);
//   }
// };


// return(

// <div className="form-box">

// <h2>Sign In</h2>

// <form onSubmit={handleSubmit}>

// <input
// type="email"
// name="username"
// placeholder="Username"
// value={formData.username}
// onChange={handleChange}
// required
// />


// <input
// type="password"
// name="password"
// placeholder="Password"
// value={formData.password}
// onChange={handleChange}
// required
// />


// <button
// className="submit-btn"
// disabled={loading}
// >

// {
// loading
// ? "Signing In..."
// : "Login"
// }

// </button>

// </form>

// </div>

// )

// }

// export default Login;


// import React, { useState } from "react";
// import axios from "axios";
// import { useNavigate } from "react-router-dom";
// import { toast } from "react-toastify";

// function Login() {
//   const navigate = useNavigate();

//   const [formData, setFormData] = useState({
//     username: "", // This is mapped to the Email input field
//     password: ""
//   });

//   const [errors, setErrors] = useState({});
//   const [loading, setLoading] = useState(false);
//   const Base_URL = process.env.REACT_APP_API_BASE_URL;

//   // Real-time validation rule checking
//   const validateField = (name, value) => {
//     let errorMsg = "";

//     if (!value.trim()) {
//       errorMsg = `${name === "username" ? "Email" : "Password"} is required.`;
//     } else if (name === "username") {
//       // Standard email structural regex check
//       const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
//       if (!emailRegex.test(value)) {
//         errorMsg = "Please enter a valid email address.";
//       }
//     }

//     setErrors((prev) => ({
//       ...prev,
//       [name]: errorMsg
//     }));
//   };

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData({
//       ...formData,
//       [name]: value
//     });

//     validateField(name, value);
//   };

//   // Form-wide checker prior to making API calls
//   const isFormValid = () => {
//     const newErrors = {};

//     // Catch fields left completely untouched
//     Object.keys(formData).forEach((key) => {
//       if (!formData[key].trim()) {
//         newErrors[key] = `${key === "username" ? "Email" : "Password"} is required.`;
//       }
//     });

//     const combinedErrors = { ...errors, ...newErrors };
//     setErrors(combinedErrors);

//     // If any error message string is present, fail validation
//     return !Object.values(combinedErrors).some((error) => error !== "");
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     if (!isFormValid()) return;

//     setLoading(true);

//     try {
//       const res = await axios.post(
//         `${Base_URL}/api/login/`,
//         formData
//       );

//       console.log("login response", res.data);

//       const { token, role, user_id } = res.data;

//       // Store Auth Tokens securely
//       localStorage.setItem("token", token.token); 
//       localStorage.setItem("refresh", token.refresh);

//       // Store contextual profile references
//       localStorage.setItem("user", JSON.stringify({
//         id: user_id,
//         role: role
//       }));

//       if (role === "Admin") {
//         navigate("/admin/dashboard");
//       } else if (role === "PM") {
//         navigate("/pm/dashboard");
//       } else {
//         alert("Unknown role: " + role);
//       }

//     } catch (err) {
//       console.error(err.response?.data || err);
      
//       // Inject general back-end API credential rejects right to the UI inputs
//       toast.error(err.response?.data?.error || "Invalid credentials setup.");
//       setErrors({
//         username: err.response?.data?.error || "Invalid credentials setup.",
//         password: " " // Passes a blank space so the password box lights up red too
//       });

//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <div className="form-box">
//       <h2>Sign In</h2>

//       <form onSubmit={handleSubmit} noValidate>
        
//         {/* Username/Email Input container */}
//         <div className={`input-group ${errors.username ? "has-error" : ""}`}>
//           <input
//             type="email"
//             name="username"
//             placeholder="Email Address"
//             value={formData.username}
//             onChange={handleChange}
//           />
//           {errors.username && <span className="error-text">{errors.username}</span>}
//         </div>

//         {/* Password Input container */}
//         <div className={`input-group ${errors.password ? "has-error" : ""}`}>
//           <input
//             type="password"
//             name="password"
//             placeholder="Password"
//             value={formData.password}
//             onChange={handleChange}
//           />
//           {errors.password && <span className="error-text">{errors.password}</span>}
//         </div>

//         <button className="submit-btn" disabled={loading}>
//           {loading ? "Signing In..." : "Login"}
//         </button>
//       </form>
//     </div>
//   );
// }

// export default Login;


import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
// OPTIONAL: Install lucide-react or react-icons for these icons, 
// or you can substitute them with simple text strings like "Show"/"Hide"
import { Eye, EyeOff } from "lucide-react"; 

function Login() {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    username: "", 
    password: ""
  });

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false); // NEW: Controls eye visibility state
  
  const Base_URL = process.env.REACT_APP_API_BASE_URL;

  // Real-time validation rule checking
  const validateField = (name, value) => {
    let errorMsg = "";

    if (!value.trim()) {
      errorMsg = `${name === "username" ? "Email" : "Password"} is required.`;
    } else if (name === "username") {
      const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      if (!emailRegex.test(value)) {
        errorMsg = "Please enter a valid email address.";
      }
    }

    setErrors((prev) => ({
      ...prev,
      [name]: errorMsg
    }));
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });

    // FIX: Clear API errors immediately when user begins correcting fields, prevents lockout state
    validateField(name, value);
  };

  // Form-wide checker prior to making API calls
  const isFormValid = () => {
    const newErrors = {};

    Object.keys(formData).forEach((key) => {
      if (!formData[key].trim()) {
        newErrors[key] = `${key === "username" ? "Email" : "Password"} is required.`;
      }
    });

    const combinedErrors = { ...errors, ...newErrors };
    setErrors(combinedErrors);

    return !Object.values(combinedErrors).some((error) => error && error.trim() !== "");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!isFormValid()) return;

    setLoading(true);

    try {
      const res = await axios.post(
        `${Base_URL}/api/login/`,
        formData
      );

      console.log("login response", res.data);
      const { token, role, user_id } = res.data;

      localStorage.setItem("token", token.token); 
      localStorage.setItem("refresh", token.refresh);
      localStorage.setItem("user", JSON.stringify({ id: user_id, role: role }));

      if (role === "Admin") {
        navigate("/admin/dashboard");
      } else if (role === "PM") {
        navigate("/pm/dashboard");
      } else {
        toast.error("Unknown user classification framework role: " + role);
      }

    } catch (err) {
      console.error(err.response?.data || err);
      const apiError = err.response?.data?.error || "Invalid credentials setup.";
      
      toast.error(apiError);
      
      // FIX: Set password error to a clean string instead of a blank space " " to avoid breaking state verification
      setErrors({
        username: apiError,
        password: "Authentication validation failed." 
      });

    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="form-box">
      <h2>Sign In</h2>

      <form onSubmit={handleSubmit} noValidate>
        
        {/* Username/Email Input container */}
        <div className={`input-group ${errors.username ? "has-error" : ""}`}>
          <input
            type="email"
            name="username"
            placeholder="Email Address"
            value={formData.username}
            onChange={handleChange}
          />
          {errors.username && <span className="error-text">{errors.username}</span>}
        </div>

        {/* Password Input container with NEW Inline Eye Wrapper */}
        <div className={`input-group ${errors.password ? "has-error" : ""}`} style={{ position: "relative" }}>
          <input
            type={showPassword ? "text" : "password"} // Dynamic Input Type Switch
            name="password"
            placeholder="Password"
            value={formData.password}
            onChange={handleChange}
            style={{ paddingRight: "40px" }} // Makes room so text won't hide under the icon
          />
          
          {/* Eye Icon Action Trigger */}
          <button
  type="button" // Critical: stops button from firing form submit actions accidentally
  onClick={() => setShowPassword(!showPassword)}
  className="password-toggle-btn" // Added a class name for better style target rules
  style={{
    position: "absolute",
    right: "14px",                 /* Margins optimized slightly further out */
    top: "50%",
    transform: "translateY(-50%)",
    background: "none",
    border: "none",
    cursor: "pointer",
    color: "#94a3b8",              /* Deeper slate gray looks cleaner against white input fields */
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "6px",                /* Increased tap target area layout matrix for better mobile usability */
    borderRadius: "50%",           /* Circular frame border wrapper */
    outline: "none",
    transition: "all 0.2s ease-in-out", /* Smooth transition animation layer */
  }}
  onMouseEnter={(e) => {
    e.currentTarget.style.color = "#6366f1"; /* Changes to your beautiful primary theme purple on hover */
    e.currentTarget.style.backgroundColor = "rgba(99, 102, 241, 0.08)"; /* Light ghost tint circle effect */
  }}
  onMouseLeave={(e) => {
    e.currentTarget.style.color = "#94a3b8";
    e.currentTarget.style.backgroundColor = "transparent";
  }}
>
  {/* The micro-sizing transition works seamlessly with the component state mapping */}
  <div style={{
    display: "flex",
    transform: "scale(1)",
    transition: "transform 0.1s ease",
  }} 
  onMouseDown={(e) => e.currentTarget.style.transform = "scale(0.9)"}
  onMouseUp={(e) => e.currentTarget.style.transform = "scale(1)"}
  >
    {showPassword ? <Eye size={19} /> : <EyeOff size={19} />}
  </div>
</button>
          {/* <button
            type="button" // Critical: stops button from firing form submit actions accidentally
            onClick={() => setShowPassword(!showPassword)}
            style={{
              position: "absolute",
              right: "12px",
              top: "50%",
              transform: "translateY(-50%)",
              background: "none",
              border: "none",
              cursor: "pointer",
              color: "#64748b",
              display: "flex",
              alignItems: "center",
              padding: 0
            }}
          >
            {showPassword ? <Eye size={18} /> :<EyeOff size={18} /> }
          </button> */}

          {errors.password && <span className="error-text">{errors.password}</span>}
        </div>

        <button className="submit-btn" disabled={loading}>
          {loading ? "Signing In..." : "Login"}
        </button>
      </form>
    </div>
  );
}

export default Login;